export const mobileUpper = 768;
export const tabletUpper = 1024;

const viewportWidths = [2400, 2048, 1536, 1200, tabletUpper, mobileUpper, 576];

export default viewportWidths;
